/**
 * Order type discriminator matching `dbo.OrderTypes.Id` and the backend
 * `Linde.HeRG.Orders.Model.OrderType` enum. Kept in its own module so both
 * list views and form definitions can import it without creating a cycle.
 */
export enum OrderType {
  Gas = 1,
  Liquid = 2,
  Dewar = 3,
}

// Shared by the Orders list tabs so fast typing / filter toggling issues one query,
// and a filter/search on data older than 5 minutes refetches it first.
export const ordersListDebounce = {
  searchDebounceMs: 1000,
  filterDebounceMs: 1000,
  staleRefetchMs: 5 * 60 * 1000,
};

// True when the order-type multiselect filter has Gas and Liquid toggled off and
// Dewar on (Dewar-only view). The multiselect stores selection as
// { [typeId]: truthy | false }. Used to conditionally show the wide Manifest column.
export const isDewarOnlyFilter = (filtersState: any): boolean => {
  const ot = filtersState?.orderTypeId;
  if (!ot) return false;
  return !ot[OrderType.Gas] && !ot[OrderType.Liquid] && !!ot[OrderType.Dewar];
};
